import React from 'react';
import { Card, Table, Tag, Typography } from 'antd';
import { getSmsDraftColumns, getEmailDraftColumns } from './tableColumns';

const { Text } = Typography;

interface DraftViewProps {
  type: 'sms' | 'email';
  data: any;
  loading: boolean;
  onEditDraft: (record: any) => void;
  onDeleteDraft: (record: any) => Promise<void>;
}

const DraftView: React.FC<DraftViewProps> = ({
  type,
  data,
  loading,
  onEditDraft,
  onDeleteDraft,
}) => {
  if (loading) {
    return (
      <div
        style={{
          padding: '60px 0',
          textAlign: 'center',
          fontSize: '16px',
          color: '#666',
        }}
      >
        <div style={{ fontSize: '24px', marginBottom: '16px' }}>⏳</div>
        Loading drafts...
      </div>
    );
  }

  const records = data?.data?.records || [];
  const columns =
    type === 'sms'
      ? getSmsDraftColumns({ onEditDraft, onDeleteDraft })
      : getEmailDraftColumns({ onEditDraft, onDeleteDraft });
  const title = type === 'sms' ? 'SMS Drafts' : 'Saved Notes';
  const color = type === 'sms' ? 'green' : 'blue';
  const borderColor = type === 'sms' ? '#f6ffed' : '#e8f4fd';

  if (records.length === 0) {
    return (
      <div
        style={{
          padding: '60px 20px',
          textAlign: 'center',
          backgroundColor: '#fafafa',
          borderRadius: '8px',
          border: '1px solid #f0f0f0',
        }}
      >
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📭</div>
        <Text type="secondary" style={{ fontSize: '16px', fontWeight: '500' }}>
          No {type === 'sms' ? 'SMS' : 'Email'} draft found.
        </Text>
      </div>
    );
  }

  return (
    <Card
      title={
        <div
          style={{
            fontSize: '16px',
            fontWeight: '600',
            color: type === 'sms' ? '#52c41a' : '#1890ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {title}
            <Tag color={color} style={{ fontSize: '12px' }}>
              {records.length} records
            </Tag>
          </div>
          <div
            style={{
              fontSize: '12px',
              color: '#666',
              fontWeight: 'normal',
            }}
          >
            Last updated:{' '}
            {new Date().toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })}
          </div>
        </div>
      }
      style={{
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: `1px solid ${borderColor}`,
      }}
    >
      <div style={{ marginTop: '-16px' }}>
        <Table
          className="send-note-table"
          columns={columns}
          dataSource={records}
          rowKey="id"
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
            size: 'small',
          }}
          scroll={{ x: type === 'sms' ? 460 : 580, y: 420 }}
          size="middle"
          style={{
            fontSize: '13px',
            backgroundColor: '#fafafa',
            marginTop: 0,
          }}
          rowClassName={(record, index) =>
            index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
          }
        />
      </div>
    </Card>
  );
};

export default DraftView;

